import type { TenantConfig } from "./types";

// huayu — 华予教育(HUAYUJY.COM)客户 demosite(2026-08-14)。
// 跑在 .147(ang-demo1)自带的 nova-os 上,域名
// school-huayu.os.meganovaai.com;数据与 librademo 同款全虚构 dummy,
// logo 打包在 UI 静态资源里(不依赖 nova-os brand 资产)。
export const huayuTenant: TenantConfig = {
  slug: "huayu",
  displayName: "华予教育",
  tagline: "HUAYUJY.COM",
  defaultLocale: "zh-CN",
  subjects: [
    { agentId: "chemistry-assistant", labelKey: "chat.subjects.chemistry" },
    { agentId: "math-assistant", labelKey: "chat.subjects.math" },
    { agentId: "english-assistant", labelKey: "chat.subjects.english" },
  ],
  brand: {
    logoSrc: "/brand-huayu.png",
  },
};
